<template>
  <div class="w-full h-full flex flex-col">
    <Loading v-show="loading" :loading="loading" />
    <div class="flex-1 overflow-y-auto">
      <div class="grid grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-10">
        <RadioBoxControl v-for="candidate in candidates" :key="candidate.code" :candidate="candidate"
          :isSelected="selectedVotes.includes(candidate.code)" :is_elecom="true" @select="toggleVote" />
      </div>
    </div>
  </div>

  <ModalControl v-show="show_message_modal" :display="show_message_modal" :error="error" :success="success"
    :note="warning" z_value="z-50" @positiveClick="handlePositiveClick" :positiveButton="'OK'"
    :default_width="'max-w-xl'" id="vote_modal">
    <div class="w-full px-5 pt-2 pb-4 flex flex-col text-lg lg:text-xl text-center">
      {{ modal_message }}
    </div>
  </ModalControl>

  <ModalControl v-show="complete_modal" :display="complete_modal" 
    :note="true" z_value="z-50" @positiveClick="handlePositiveClick" :positiveButton="'OK'"
    :default_width="'max-w-xl'" id="vote_modal">
    <div class="w-full px-5 pt-2 pb-4 flex flex-col text-lg lg:text-xl text-center">
      You have already selected the maximum number of candidates for this category. Please deselect a candidate and select again.
    </div>
  </ModalControl>

  <ModalControl v-show="ack_notice" :display="ack_notice" :note="true" z_value="z-50"
    @positiveClick="ackNotice" :positiveButton="'OK'" :default_width="'max-w-xl'" id="vote_modal">
    <div class="w-full px-5 pt-2 pb-4 flex flex-col text-base lg:text-lg text-center">
        <p class="mb-2 lg:mb-10">Please select One (1) Candidate for the Election Committee Position.</p>
        <p class="p-2 lg:p-4 rounded-full px-10 my-2 lg:my-4 bg-gray-100 w-auto">1 - Civilian</p>
    </div>
  </ModalControl>
</template>

<script>
import { defineComponent } from 'vue';
import Loading from '@/components/controls/LoadingControl.vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import RadioBoxControl from '@/components/controls/RadioBoxControl.vue';

export default defineComponent({
  components: {
    Loading,
    ModalControl,
    RadioBoxControl,
  },

  data() {
    return {
      loading: false,
      show_message_modal: false,
      complete_modal: false,
      modal_message: '',
      success: false,
      warning: false,
      error: false,
      ack_notice: false,
    };
  },
  watch: {
    isCompleted: {
      immediate: true,
      handler(val) {
        this.$emit('completed', val);
      }
    }
  },
  mounted() {
    this.openNotice();
  },
  computed: {
    isCompleted() {
      return this.selectedVotes.length === 1;
    },
    selectedVotes() {
      return this.$store.state.selectedVotes.elecom;
    },
    candidates() {
      const bod = this.$store.state.gaCandidates?.elecom || [];
      return bod.map(c => ({
        code: c.code,
        name: c.name,
        type: c.type,
        image: c.photo
      }));
    },
    selectedCandidates() {
      return this.candidates.filter(c =>
        this.selectedVotes.includes(c.code)
      );
    },
    officerCount() {
      return this.selectedCandidates.filter(c => c.type === 'OFFICER').length;
    },

    epCount() {
      return this.selectedCandidates.filter(c => c.type === 'ENLISTED PERSONNEL').length;
    },

    civilianCount() {
      return this.selectedCandidates.filter(c => c.type === 'CIVILIAN').length;
    },
  },

  methods: {
    openNotice() {
      if (this.$store.state.ackNotice.elecom) {
        this.ack_notice = false;
      } else {
        this.ack_notice = true;
      }
    },
    ackNotice() {
      this.ack_notice = false;
      this.$store.state.ackNotice.elecom = true;
    },
    clearVotes() {
      this.selectedVotes = [];
    },
    toggleVote(candidate) {
      const index = this.selectedVotes.indexOf(candidate.code);
      let updated = [...this.selectedVotes];
      
      if (index === -1) {
        if (this.selectedVotes.length < 1) {
          updated.push(candidate.code);
          this.$store.commit('setSelectedVotes', { category: 'elecom', votes: updated });
        } else {
          this.complete_modal = true;
        }
      } else {
        updated.splice(index, 1);
        this.$store.commit('setSelectedVotes', { category: 'elecom', votes: updated });
      }
    },

    handlePositiveClick() {
      this.show_message_modal = false;
      this.complete_modal = false;
    }
  }
});
</script>

<style scoped>
.max-width-back {
  max-width: 50px;
}
</style>
